module.exports = __webpack_public_path__ + "media/images/icons/SVG/044-f0197f72e52045c3e19bdd3cbd0720bc.svg";